
const prodBaseURL = 'https://api.northswing.ca';
const devBaseURL = 'http://localhost:1337';
// const devBaseURL = 'https://api.northswing.ca';
export default {
  apiBaseURL: process.env.NODE_ENV === 'production' ? prodBaseURL : devBaseURL,
};
